module.exports = __webpack_public_path__ + "img/Claim Orders.9f1d4699.jpg";